const Style = {

  tabs: 'overflow-hidden border-b border-solid border-sg-line md:inline-flex md:border-0',
  button: `relative float-left w-full px-10 py-3 outline-none text-sm
    ease-in-out duration-300 border-b border-solid border-sg-line last:border-0
    md:w-auto md:border-0 md:border-b-2 md:last:border-b-2 md:border-solid`,

  buttonActive: 'text-white bg-sg-blue md:text-sg-blue md:bg-transparent md:border-sg-blue',
  buttonInActive: 'text-sg-slate bg-white hover:text-sg-ink md:bg-transparent md:border-transparent',

}

export default Style;